/**
 * Cache key for experience search burn batch calculations.
 * Excludes Société UI-only URL flags so toggling burn modes does not wipe cached tile pricing.
 */
export function getExperienceSearchBurnCalculationKey(
  searchFilters: Experiences.SearchFilters,
): string {
  const { viewPriceInPoints: _viewPriceInPoints, ...searchCriteria } = searchFilters
  return JSON.stringify(searchCriteria)
}
